import React from "react";

import {L4} from "../../services/NetworkApi";

import { EnhancedTreeItem } from "./EnhancedTreeItem";
import { useUpdateRoom } from "./useUpdateRoom";
import { IProps as ISubnetworksTreeProps } from "./SubnetworksTree";
import {RoomDeleteButtonWrapper} from "./RoomDeleteButton";

interface IProps extends ISubnetworksTreeProps {
  l4: L4;
  l1Id: number;
  l2Id: number;
  l3Id: number;
  nodeId: string;
}

export const RoomTreeItem: React.FC<IProps> = (props) => {
  const {handleRename, handleNumberInL3Update} = useUpdateRoom(props.l2Id, props.l3Id, props.l4.l4Id);

  const title = props.isPreview ? `ROOM: ${props.l4.name}` : `Room Name: ${props.l4.name}`;
  const subtitle2 = props.isPreview
    ? `MAX USERS IN ROOM: ${props.l4.numberInL3}`
    : `Number in L3: ${props.l4.numberInL3}`;

  return (
    <EnhancedTreeItem
      name={props.l4.name}
      nodeId={props.nodeId}
      isPreview={props.isPreview}
      onEdit1Success={handleRename}
      title={title}
      subtitle1={`L4 Id: ${props.l4.l4Id}`}
      subtitles={[
          {title: subtitle2, value: props.l4.numberInL3, onEdit: handleNumberInL3Update}
      ]}
      deleteButton={<RoomDeleteButtonWrapper levelName={props.l4.name} l1Id={props.l1Id} l2Id={props.l2Id} l3Id={props.l3Id} l4Id={props.l4.l4Id}/>}
    />
  );
};
